import { render, staticRenderFns } from "./WorkFlow.vue?vue&type=template&id=13a27d55&"
import script from "./WorkFlow.vue?vue&type=script&lang=js&"
export * from "./WorkFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.4@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports